<template>
    <v-card>
        <v-form
            ref="identityFindAddForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <!--<v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="identityTypes"
                                :rules="[requiredRule]"
                                @input="$refs.identityFindAddForm.validate()"
                                item-text="value"
                                item-value="key"
                                label="Identity Type"
                                v-model="type"
                            ></v-select>
                        </v-col>-->
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[validRSAID,requiredRule,lengthRule(20)]"
                                label="Identification Number (RSA ID, Passport, etc.)"
                                ref="idNumber"
                                v-model="number"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isLocating"
                            :loading="isLocating"
                            @click="locateIdentity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Next</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-dialog
            persistent
            v-model="identityFormVisible"
            width="500px"
        >
            <IdentityForm
                :auto-close="true"
                :identity-in="identityFormIdentity"
                :key="identityFormKey"
                :preset-identity="true"
                @close="closeIdentityForm"
                @saved="newIdentityLocated"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import uuid4 from "../../helpers/uuid4";
import Identity from "../../models/Identity.model";
import IdentityForm from "./IdentityForm";
export default {
    props: 
        ['allowDeceased']
        //
    ,
    components: {
        IdentityForm
        //
    },
    mounted: async function() {
        //this.identityTypes = await this.$store.dispatch("identities/getTypes");
    },
    data() {
        return {
            identityTypes: null,
            identity: null,
            isValid: null,
            isLoading: null,
            isLocating: null,
            type: null,
            number: null,
            requestId: null,

            identityFormVisible: false,
            identityFormKey: null,
            identityFormIdentity: new Identity(),

            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,

            requiredRule: v => !!v || "required",
            validRSAID: v => {
                if (this.type != 1 && this.type != 4) return true;

                var invalidId = "invalid RSA Id";
                if (!v || v.length != 13) return invalidId;

                var idNumbers;
                try {
                    idNumbers = v.split("").map(x => parseInt(x));
                } catch {
                    return invalidId;
                }

                if (idNumbers[10] > 1) return invalidId;

                var evens = [
                    idNumbers[1],
                    idNumbers[3],
                    idNumbers[5],
                    idNumbers[7],
                    idNumbers[9],
                    idNumbers[11]
                ];

                var odds = [
                    idNumbers[0],
                    idNumbers[2],
                    idNumbers[4],
                    idNumbers[6],
                    idNumbers[8],
                    idNumbers[10],
                    idNumbers[12]
                ];

                var evensLuhnSum = evens
                    .map(x => {
                        var d = 2 * x;
                        if (d > 9) {
                            var dstring = d.toString();
                            d = parseInt(dstring[0]) + parseInt(dstring[1]);
                        }
                        return d;
                    })
                    .reduce((a, b) => a + b, 0);

                var oddsSum = odds.reduce((a, b) => a + b, 0);

                return (evensLuhnSum + oddsSum) % 10 == 0 || invalidId;
            },
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        emitLocatedIdentity(locatedIdentity) {
            
            if(locatedIdentity.deceased === true && !this.allowDeceased)
            {
                this.notify(
                            "This identity is deceased and cannot be selected.",
                            "error"
                        );
            }else
            {
                this.$emit("located", locatedIdentity);
                this.closeForm();
            }
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        validateForm() {
            this.$refs.identityFindAddForm.validate();
        },
                notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        //new identity located ------------------------------------------
        newIdentityLocated(identityWithInfo) {
            this.emitLocatedIdentity(identityWithInfo.entity);
        },
        //locate      ------------------------------------------------------------
        locateIdentity() {
            this.validateForm();
            if (this.isValid) {
                this.isLoading = true;
                this.isLocating = true;

                var requestId = (this.requestId = uuid4());
                this.requestId = requestId;
                this.$store
                    .dispatch("identities/getByIdentificationTypeAndNumber", {
                        id: null,
                        urlParameters: {
                            //type: this.type,
                            number: this.number
                        },
                        requestId: requestId
                    })
                    .then(identitiesResponse => {
                        if (identitiesResponse.requestId == this.requestId) {
                            if (identitiesResponse.data) {
                                this.emitLocatedIdentity(identitiesResponse.data);
                            } else {
                                this.identityFormKey = 0;
                                this.identityFormIdentity = new Identity();
                                this.identityFormIdentity.id = 0;
                                //this.identityFormIdentity.identityTypeId = this.type;
                                this.identityFormIdentity.identificationNumber = this.number;
                                this.identityFormVisible = true;
                            }
                        }
                    })
                    .finally(this.locateIdentityDone);
            }
        },
        locateIdentityDone() {
            this.isLoading = false;
            this.isLocating = false;
        },
        closeForm() {
            this.emitCloseForm();
        },
        closeIdentityForm() {
            this.identityFormVisible = false;
            this.identityFormIdentity = new Identity();
            this.identityFormKey = null;
        }
    }
};
</script>

<style lang="stylus" scoped></style>